module.exports = __webpack_public_path__ + "static/media/Akia W.02d7775e.jpg";